import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import GetfVDateFormate from "../../../utils/Genaricfunctions";

export default function MainInformation({ data, dataChange }) {
  const { t } = useTranslation();
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
      borderSpacing: "10px",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const headColumns = ["dateofinterimfinancialstatement"];
  const headColumns1 = ["financialYearEndDate"];
  const headColumns3 = ["sourceOfFinancialStatements"];
  const [value, setValue] = React.useState(data[0]?.dateofinterimfinancialstatement); 
  
  
  
  useEffect(()=>{
    const _date = new Date(data[0]?.dateofinterimfinancialstatement);
    if(value  != _date){
      setValue(data[0]?.dateofinterimfinancialstatement)
    }
    },[data])
  
  // useEffect(()=>{
  //   console.log("date",value);
  // },[value])

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>&nbsp;</StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                {"Current YTD"}
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                {"Previous Year"}{" "}
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                {"2 Years Previous"}
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                {"3 Years Previous"}&nbsp;
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {headColumns1.map((r, index) => (
              <TableRow key={index}>
                <StyledTableCell>{t(r)}</StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  {GetfVDateFormate(data?.[0]?.[r])}
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  {GetfVDateFormate(data?.[1]?.[r])}
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  {GetfVDateFormate(data?.[2]?.[r])}
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  {GetfVDateFormate(data?.[3]?.[r])}
                </StyledTableCell>
              </TableRow>
            ))}
            {headColumns.map((r, index) => (
              <TableRow key={index}>
                <StyledTableCell>{t(r)}</StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={value}
                      onChange={(event) => {
                        //setValue(event);
                       const date = event.$d;
                        //const offsetMinutes = date.getTimezoneOffset();
                        //date.setMinutes(date.getMinutes() + offsetMinutes);
                         dataChange(0, r, date);
                      }}
                      renderInput={(params) => (
                        <TextField
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width:"250px"
                          }}
                          size="small"
                          onKeyDown={(e) => e.preventDefault()}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={value1}
                      hidden={true}
                      onChange={(event) => {
                        setValue1(event);
                        dataChange(1, r, event.$d);
                      }}
                      renderInput={(params) => (
                        <TextField
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider> */}
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      hidden={true}
                      value={value2}
                      onChange={(event) => {
                        setValue2(event);
                        dataChange(2, r, event.$d);
                      }}
                      renderInput={(params) => (
                        <TextField
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          {...params}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider> */}
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                    hidden={true}
                      value={value3}
                      onChange={(event) => {
                        setValue3(event);
                        dataChange(3, r, event.$d);
                      }}
                      renderInput={(params) => (
                        <TextField
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          {...params}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider> */}
                </StyledTableCell>
              </TableRow>
            ))}
            {headColumns3.map((r, index) => (
              <TableRow key={index}>
                <StyledTableCell>{t(r)}</StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <FormControl fullWidth >
                    <Select
                      placeholder="select"
                      id="demo-simple-select"
                      value={data[0]?.sourceOfFinancialStatements}
                      label="Age"
                      onChange={(event) => dataChange(0, r, event.target.value)}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width:"250px",
                        marginLeft:"40px"
                      }}
                      
                      size="small"
                    >
                      <MenuItem value={"Audited"}>Audited</MenuItem>
                      <MenuItem value={"Internal"}>Internal</MenuItem>
                      <MenuItem value={"Compiled"}>Compiled</MenuItem>
                      <MenuItem value={"Reviewed"}>Reviewed</MenuItem>
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <FormControl fullWidth>
                    <Select
                      placeholder="select"
                      id="demo-simple-select"
                      value={data[1]?.sourceOfFinancialStatements}
                      label="Age"
                      onChange={(event) => dataChange(1, r, event.target.value)}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width:"250px"
                      }}
                      size="small"
                    >
                      <MenuItem value={"Audited"}>Audited</MenuItem>
                      <MenuItem value={"Internal"}>Internal</MenuItem>
                      <MenuItem value={"Compiled"}>Compiled</MenuItem>
                      <MenuItem value={"Reviewed"}>Reviewed</MenuItem>
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <FormControl fullWidth>
                    <Select
                      placeholder="select"
                      id="demo-simple-select"
                      value={data[2]?.sourceOfFinancialStatements}
                      label="Age"
                      onChange={(event) => dataChange(2, r, event.target.value)}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width:"250px"
                      }}
                      size="small"
                    >
                      <MenuItem value={"Audited"}>Audited</MenuItem>
                      <MenuItem value={"Internal"}>Internal</MenuItem>
                      <MenuItem value={"Compiled"}>Compiled</MenuItem>
                      <MenuItem value={"Reviewed"}>Reviewed</MenuItem>
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <FormControl fullWidth>
                    <Select
                      placeholder="select"
                      id="demo-simple-select"
                      value={data[3]?.sourceOfFinancialStatements}
                      label="Age"
                      onChange={(event) => dataChange(3, r, event.target.value)}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width:"250px"
                      }}
                      size="small"
                    >
                      <MenuItem value={"Audited"}>Audited</MenuItem>
                      <MenuItem value={"Internal"}>Internal</MenuItem>
                      <MenuItem value={"Compiled"}>Compiled</MenuItem>
                      <MenuItem value={"Reviewed"}>Reviewed</MenuItem>
                    </Select>
                  </FormControl>
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}